var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBrowser = function SvgBrowser(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166748 4.83329C0.166748 2.53211 2.03223 0.666626 4.33341 0.666626H32.6667C34.9679 0.666626 36.8334 2.53211 36.8334 4.83329V33.1666C36.8334 35.4678 34.9679 37.3333 32.6667 37.3333H4.33341C2.03223 37.3333 0.166748 35.4678 0.166748 33.1666V4.83329ZM4.33341 3.99996C3.87318 3.99996 3.50008 4.37305 3.50008 4.83329V33.1666C3.50008 33.6269 3.87318 34 4.33341 34H32.6667C33.127 34 33.5001 33.6269 33.5001 33.1666V4.83329C33.5001 4.37305 33.127 3.99996 32.6667 3.99996H4.33341Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00016 8.16659C6.92064 8.16659 7.66683 7.42039 7.66683 6.49992C7.66683 5.57944 6.92064 4.83325 6.00016 4.83325C5.07969 4.83325 4.3335 5.57944 4.3335 6.49992C4.3335 7.42039 5.07969 8.16659 6.00016 8.16659Z",
    fill: "#0258FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1667 8.16659C11.0871 8.16659 11.8333 7.42039 11.8333 6.49992C11.8333 5.57944 11.0871 4.83325 10.1667 4.83325C9.24619 4.83325 8.5 5.57944 8.5 6.49992C8.5 7.42039 9.24619 8.16659 10.1667 8.16659Z",
    fill: "#0258FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3334 8.16659C15.2539 8.16659 16.0001 7.42039 16.0001 6.49992C16.0001 5.57944 15.2539 4.83325 14.3334 4.83325C13.4129 4.83325 12.6667 5.57944 12.6667 6.49992C12.6667 7.42039 13.4129 8.16659 14.3334 8.16659Z",
    fill: "#0258FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166748 9H36.8334V12.3333H0.166748V9Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrowser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/browser.459acf64.svg";
export { ForwardRef as ReactComponent };